<template>
  <div>
    <PopoverLastTelemetryTimestamp :deviceId="deviceId" />
    <OneMeasurementMonitoring
      :deviceId="deviceId"
      :selectedParameter="selectedParameter"
      :readings="readings"
      size="large"
    />
    <DeviceConditions :deviceId="deviceId" :lastTelemetryTimestamp="lastTelemetryTimestamp" />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import OneMeasurementMonitoring from '@/components/devicePopover/layouts/OneMeasurementMonitoring.vue'
import PopoverLastTelemetryTimestamp from '@/components/devicePopover/content/header/popoverLastTelemetryTimestamp.vue'
import DeviceConditions from '@/components/widgets/currentReadings/content/DeviceConditions.vue'
import { MeasurementType } from '@/services/device-measurements'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'
import type { GetterByDeviceId } from '../types'
import type { SensorReadings } from '@/services/device-service/devices'

export default defineComponent({
  name: 'ContinuousMonitoringContent',
  components: {
    OneMeasurementMonitoring,
    PopoverLastTelemetryTimestamp,
    DeviceConditions
  },
  props: {
    deviceId: {
      type: String,
      default: ''
    },
    selectedParameter: {
      type: Number as PropType<MeasurementType>,
      default: MeasurementType.Pm25
    }
  },
  computed: {
    lastTelemetryTimestamp(): string {
      const getter = this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_LAST_CONTACT_BY_DEVICE_ID}`
      ] as GetterByDeviceId<string>
      return getter(this.deviceId)
    },
    readings(): SensorReadings {
      const getter = this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_SENSOR_READINGS_BY_DEVICE_ID}`
      ] as GetterByDeviceId<SensorReadings>
      return getter(this.deviceId)
    }
  }
})
</script>
